import { SEARCH_WHITELIST } from './searchParameterNames';

/*--------------------------------------------
- Read and store the url parameters
---------------------------------------------*/

// This function is used to read the url parameters,
// return the parameters as a key/value object (to store them in
// the PageContext of the component 'PageTemplate').

export function handleUrlParameters(location) {

	// no search in location
	if (!location.search) {
		return {};
	}

	// initial parameters
	const parametersData = {};

	// get parameters
	location.search.replace(/^\?/, '').split('&').forEach((parameter) => {
		const keyValue = parameter.split('=');
		const [key, value] = keyValue.map(item => {
			item = item.replace(/\+/g, '%20');
			return decodeURIComponent(item);
		});

		if (SEARCH_WHITELIST.includes(key)) {
			parametersData[key] = value;
		} else if (import.meta.env.DEV) {
			// eslint-disable-next-line no-console
			console.warn(`niet gedefinieerde urlParameters : ${key}=${value}`);
		}
	});

	// return parameter data
	return parametersData;
}
